<template>
  <div :style="{
    gridColumnEnd: 'span ' + cols,
  }"
       >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DdFormGridItem",
  props: {
    cols: {
      required: false,
      default: () => 1,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>